import axios from '@/core/http'

const fetchProxyList = () => {
  return axios.get('spiders/proxy-lists/').then(res => res.data['results'])
}

export { fetchProxyList }
